const component = "base-tree";

export const baseTree = {
  component,
  searchInput: {
    label: `${component}/search-input/label`,
    input: `${component}/search-input/input`,
  },
  chips: {
    component: `${component}/chips`,
    clearAllButton: `${component}/chips/clear-all-button`,
    selectedNodeChip: `${component}/chips/selection-chip`,
  },
  selectAll: {
    label: `${component}/select-all/label`,
    checkbox: `${component}/select-all/checkbox`,
  },
  tree: {
    container: `${component}/tree/container`,
    node: `${component}/tree/node`,
  },
};
